export default "__VITE_ASSET__D_Ne$hce__"